import React from 'react';

import ExampleNew from './example-new';
import ExampleModify from './example-modify';
import ExampleDelete from './example-delete';
import { MENU_ENTRIES } from '../../constants';

const XmlExamples = () => (
  <div data-subsection={MENU_ENTRIES.creatingRecallInXmlFormatExamples}>
    <h3>
      XML examples
    </h3>
    <p>
      This section includes examples of XML schemas for inserting, updating and deleting recalls into
      the <i>GlobalRecalls</i> portal. You can use these examples as a reference when preparing your own XML files.
    </p>
    <br/>
    <div data-subsection={MENU_ENTRIES.creatingRecallInXmlFormatExamplesNewRecall}>
      <ExampleNew/>
    </div>
    <br/><br/>
    <div data-subsection={MENU_ENTRIES.creatingRecallInXmlFormatExamplesUpdateRecall}>
      <ExampleModify/>
    </div>
    <br/><br/>
    <div data-subsection={MENU_ENTRIES.creatingRecallInXmlFormatExamplesDeleteRecall}>
      <ExampleDelete/>
    </div>
  </div>
);

export default XmlExamples;



// WEBPACK FOOTER //
// ./src/views/static/import-documentation/xml-format/xml-examples/index.js